module.exports = __webpack_public_path__ + "static/img/图片1.7b5737d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图片1.png
// module id = DDeX
// module chunks = 1